import * as React from "react";

function SvgBBiconsNemovitostiParcela(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <defs>
        <style>{".BBicons_Nemovitosti_Parcela_svg__cls-1{fill:none}"}</style>
      </defs>
      <g
        id="BBicons_Nemovitosti_Parcela_svg__Obecn\xE9_ikony"
        data-name="Obecn\xE9 ikony"
      >
        <g
          id="BBicons_Nemovitosti_Parcela_svg__Nemovitosti_-_parcela"
          data-name="Nemovitosti - parcela"
        >
          <path d="M158.21 171.78H41.78a13.58 13.58 0 01-13.56-13.57V41.79a13.58 13.58 0 0113.56-13.57h116.43a13.59 13.59 0 0113.57 13.57v116.42a13.59 13.59 0 01-13.57 13.57zM41.78 35.81a6 6 0 00-6 6v116.4a6 6 0 006 6h116.43a6 6 0 006-6V41.79a6 6 0 00-6-6z" />
          <path
            className="BBicons_Nemovitosti_Parcela_svg__cls-1"
            d="M171.78 28.22h-13.95L28.22 157.83v13.95h16.8L171.78 45.02v-16.8zM171.78 55.52L55.52 171.78h30.76l85.5-85.5V55.52zM28.22 28.22v36.6l36.6-36.6h-36.6zM116.57 28.22l-88.35 88.35v30.76L147.33 28.22h-30.76zM171.78 171.78v-33.75l-33.75 33.75h33.75zM171.78 96.78l-75 75h30.75l44.25-44.25V96.78zM75.32 28.22l-47.1 47.1v30.76l77.85-77.86H75.32z"
          />
          <path d="M127.53 171.78h10.5l33.75-33.75v-10.5l-44.25 44.25zM171.78 86.28l-85.5 85.5h10.5l75-75v-10.5zM171.78 45.02L45.02 171.78h10.5L171.78 55.52v-10.5zM147.33 28.22L28.22 147.33v10.5L157.83 28.22h-10.5zM106.07 28.22l-77.85 77.86v10.49l88.35-88.35h-10.5zM64.82 28.22l-36.6 36.6v10.5l47.1-47.1h-10.5z" />
          <path
            className="icon-stroke-color"
            d="M51.55 50.86v48.47h55.15v50.81h41.76V50.86z"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={10}
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgBBiconsNemovitostiParcela;
